import { render } from "./reservations_history_index.vue?vue&type=template&id=4fec7154"
import script from "./reservations_history_index.vue?vue&type=script&lang=js"
export * from "./reservations_history_index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__